import env from "react-dotenv";
import { parseJSON } from "../../helpers/json";
import { API_ENDPOINT } from '../../constants';

export default {
    'search': {
        onLoad: false,
        action: (query) => {
            const {customerId, sku, entries, page} = query

            let url = API_ENDPOINT + `/data/prices/${customerId}?currentPage=${page}&perPage=${entries}`;
            if (typeof sku !== 'undefined') {
                url = url + '&sku=' + sku;
            }
            return fetch(url, {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },

            }).then(parseJSON).then(({ result, status }) => {
                if (status >= 200 && status < 300)
                    return {
                        items: result.items,
                        total: result.total,
                    }
            })
        }
    },


}